<script setup lang="ts">
import AppSidebar from '@/components/domain/AppSidebar.vue'
import AppTopbar from '@/components/domain/AppTopbar.vue'
</script>

<template>
  <div class="flex h-screen w-screen overflow-hidden bg-bg-app">
    <AppSidebar />
    <div class="flex min-w-0 flex-1 flex-col">
      <AppTopbar />
      <main class="min-h-0 flex-1 overflow-auto">
        <slot />
      </main>
    </div>
  </div>
</template>
